document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.size-guide__btn');
  if (btn) {
    const handle = btn.getAttribute('data-guide-handle');
    const modal  = document.getElementById('size-guide-modal');
    const host   = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    try {
      const res = await fetch(`${host}pages/${handle}?view=plain`);
      const html = await res.text();
      document.getElementById('size-guide-content').innerHTML = html;
      modal.hidden = false; document.body.style.overflow = 'hidden';
    } catch(e){ console.error(e); alert('Could not load size guide.'); }
  }
  if (e.target.matches('[data-close]')) {
    document.getElementById('size-guide-modal').hidden = true;
    document.body.style.overflow = '';
  }
});
